module.exports = __webpack_public_path__ + "static/helm-symbol-DND3_FnP-08755bf61b65fb715734460a9fb91421.webp";